import { Component, EventEmitter, Input, Output } from '@angular/core'
import { MatSelectionListChange } from '@angular/material'

@Component({
	selector: 'atyl-nomade-dossier-renderer',
	templateUrl: './dossier-renderer.component.html',
	styleUrls: ['./dossier-renderer.component.scss']
})
export class DossierRendererComponent {

	@Input() dossier: any
	toSaveData: any = {}
	@Output() onSave: EventEmitter<any> = new EventEmitter()
	ngOnInit() {
		console.log('DossierRendererComponent.ngOnInit()', this.dossier)
	}

	selectionChanged(event: MatSelectionListChange) {
		console.log(event)
	}
	saveDossier(event: MouseEvent) {
		this.dossier.formulaires = this.toSaveData.formulaires
		// this.dossier.foyers = this.toSaveData.foyers
		this.dossier.documents = this.toSaveData.documents
		this.dossier.suivis = this.toSaveData.suivis

		this.onSave.emit(this.dossier)
	}

}
